import { createSlice } from "@reduxjs/toolkit";

const classPeriodsSlice = createSlice({
  name: "classPeriods",
  initialState: {
    classPeriodsListData : [],
    loading: false,
    error: null,
  },
  reducers: {
    getClassPeriodsRequest: (state) => {
      state.loading = true;
      state.error = null;
    },
    getClassPeriodsSuccess: (state, action) => {
      state.loading = false;
      state.classPeriodsListData = action.payload;
    },
    getClassPeriodsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearClassPeriods: (state) => {
      state.classPeriodsListData = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const {
  getClassPeriodsRequest,
  getClassPeriodsSuccess,
  getClassPeriodsFailure,
  clearClassPeriods,
} = classPeriodsSlice.actions;

export default classPeriodsSlice.reducer;
